<template>
    <div class="container-fluid fixed-top bg-primary px-lg-3 px-0" id="topnav">
        <div class="row collapse show no-gutters d-flex h-100 position-relative sidebar-collapse">
            <div class="col-3 pr-4 w-sidebar navbar-collapse collapse d-none d-lg-flex">
                <input class="form-control form-control-sm border-0 font-weight-light" type="text" placeholder="search..." />
            </div>
            <div class="col">
                <Navbar></Navbar>
            </div>
        </div>
    </div>
</template>
<script>
import Navbar from "./Navbar";

export default {
    components: {
        Navbar
    },
    props: {
      textLinkClass: {
        type: String,
        default: 'd-sm-none d-md-inline',
      }
    }
};
</script>
